import { RouteParam } from "../../../routes";
import { ACTION, MODULE } from "../../../utils/enums";
import { urls } from "../../../utils/urls";
import CustomerApprovalScreen from "../customer/customer_approval_screen";
import CustomerCreateScreen from "../customer/customer_create";
import CustomerListScreen from "../customer/customer_list";

const customer_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.customer_master,
    component: CustomerListScreen,
    module: MODULE.customer_master,
    main_module: MODULE.order_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.customer_master + "/create",
    component: CustomerCreateScreen,
    module: MODULE.customer_master,
    main_module: MODULE.order_panel,
    action: [ACTION.CREATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.customer_master + "/update/:id",
    component: CustomerCreateScreen,
    module: MODULE.customer_master,
    main_module: MODULE.order_panel,
    action: [ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.customer_master + "/view/:id",
    component: CustomerApprovalScreen,
    module: MODULE.customer_master,
    main_module: MODULE.order_panel,
    action: [ACTION.READ],
    operator: "or",
  },
];

export default customer_routes;